export default __webpack_public_path__ + "static/media/mitigation-framing-and-drying-layout.84073db8.jpg";